/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_ParametersInputs */

const en_nav_parameters = /** @type {(inputs: Nav_ParametersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parameters`)
};

/**
* | output |
* | --- |
* | "Parameters" |
*
* @param {Nav_ParametersInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_parameters = /** @type {((inputs?: Nav_ParametersInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_ParametersInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_parameters(inputs)
});